/* Macht beliebige Tabellen auf Produktseiten horizontal bedienbar. */
(function () {
  'use strict';

  function enhanceTables(root) {
    var scope = root || document;
    var tables = scope.querySelectorAll('table:not(.pb-table):not([data-ea-table-no-scroll])');

    tables.forEach(function (table) {
      if (!table.closest('main[data-template="product"]')) return;
      if (table.closest('.ea-table-scroll,.pb-tablewrap')) return;

      var wrapper = document.createElement('div');
      var caption = table.querySelector('caption');
      var label = caption && caption.textContent.trim()
        ? caption.textContent.trim()
        : 'Tabelle horizontal verschiebbar';

      wrapper.className = 'ea-table-scroll';
      wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', label);
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { enhanceTables(document); });
  } else {
    enhanceTables(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhanceTables(event.target);
  });
})();
